import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformMetricCard = ({ title, value, trend, icon, color = 'blue' }) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    purple: 'bg-purple-50 text-purple-600',
    orange: 'bg-orange-50 text-orange-600'
  };

  const trendColor = trend >= 0 ? 'text-green-600' : 'text-red-600';
  const trendIcon = trend >= 0 ? 'TrendingUp' : 'TrendingDown';

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className={`p-3 rounded-lg ${colorClasses?.[color]}`}>
          <Icon name={icon} className="w-6 h-6" />
        </div>
        <div className={`flex items-center gap-1 text-sm font-medium ${trendColor}`}>
          <Icon name={trendIcon} className="w-4 h-4" />
          <span>{Math.abs(trend)}%</span>
        </div>
      </div>
      <h3 className="text-sm font-medium text-gray-600 mb-1">{title}</h3>
      <p className="text-2xl font-bold text-gray-900">
        {typeof value === 'number' ? value?.toLocaleString() : value}
      </p>
    </div>
  );
};

export default PlatformMetricCard;